import { Client } from '@/utilities/api/Client';

export class SmsApi {
  static isPhoneNumberOwned (phoneNumber: string): Promise<boolean> {
    return Client(`sms/is-phone-number-owned/${phoneNumber}`);
  }
}